import { useEffect } from 'react';
import { useSecureFields } from '@gr4vy/secure-fields-react';
import { CardVaultFailureData } from '@gr4vy/secure-fields-react/lib/types';
import { GravyVaultSubmitRefState, GravyVaultSubmitResponse } from '../SecurePaymentForm.types';

type SecurePaymentSubmitProps = {
  vaultSubmitRef: React.MutableRefObject<GravyVaultSubmitRefState>;
};

export const SecurePaymentSubmit = ({ vaultSubmitRef }: SecurePaymentSubmitProps) => {
  const { secureFields } = useSecureFields();

  useEffect(() => {
    if (!secureFields || typeof secureFields.submit !== 'function') {
      return;
    }

    window.submitGravyVault = (
      onSubmitSuccessCallback?: () => void,
      onSubmitError?: (error: CardVaultFailureData) => void
    ) => {
      return new Promise<GravyVaultSubmitResponse>((resolve, reject) => {
        vaultSubmitRef.current = {
          onSubmitSuccessCallback,
          onSubmitError,
          resolve,
          reject,
        };

        try {
          secureFields?.submit();
        } catch (err) {
          reject(err);
        }
      });
    };
    return () => {
      if (window.submitGravyVault) {
        delete window.submitGravyVault;
      }
    };
  }, [secureFields, vaultSubmitRef]);

  return null;
};
